import { render, staticRenderFns } from "./CompaniesWeWorkWith.vue?vue&type=template&id=fceafdc0"
import script from "./CompaniesWeWorkWith.vue?vue&type=script&lang=js"
export * from "./CompaniesWeWorkWith.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports